const CRAFT_EMAIL_KEY = 'craft-email';

export const craftEmailQueryKeys = {
  all: [CRAFT_EMAIL_KEY] as const,

  createThread: (payload: unknown) => [CRAFT_EMAIL_KEY, 'create-thread', payload] as const,
  sendMessage: (payload: unknown) => [CRAFT_EMAIL_KEY, 'send-message', payload] as const,
  applyCompetitors: (payload: unknown) => [CRAFT_EMAIL_KEY, 'apply-competitors', payload] as const,
  contacts: (domain?: string, searchText?: string) => [CRAFT_EMAIL_KEY, 'contacts', domain, searchText] as const,
};
